export default __webpack_public_path__ + "static/media/beeranimal.a9a3ca17.jpg";